import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./FilterFeatureArrangementTypes.module.scss";
import {useFilterFeatureArrangementTypesLogic} from "./FilterFeatureArrangementTypes.logic";
import {FilterFeatureArrangementType} from "../filter-feature-arrangement-type/FilterFeatureArrangementType";
import {FilterArrangementTypeControls} from "../filter-arrangement-type-controls/FilterArrangementTypeControls";

export const FilterFeatureArrangementTypes: VoidFunctionComponent = () => {
  const {arrangementTypeIds} = useFilterFeatureArrangementTypesLogic();
  return (
    <ol className={s.container}>
      <li>
        <FilterArrangementTypeControls />
      </li>
      {arrangementTypeIds.map((arrangementTypeId) => <FilterFeatureArrangementType {...{arrangementTypeId}} key={`filter-arrangement-type-${arrangementTypeId}`} />)}
    </ol>
  );
}
